



























































































































import { PropType } from 'vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';
import CopyStakeJackpotCampaignDialogStreamerSelect from '@/views/CopyStake/CopyStakeGamificationCenter/Jackpot/ManageCampaignDialog/CopyStakeJackpotCampaignDialogStreamerSelect.vue';
import {
  IJackpotCampaignDetails,
  IJackpotStreamer,
  ValidationRules
} from '@/api/schema';
import { DateTime } from 'luxon';
import * as vr from '@/helpers/validation';

export default {
  name: 'CopyStakeJackpotCampaignDialogMainForm',
  components: {
    VExtendedDataPicker,
    CopyStakeJackpotCampaignDialogStreamerSelect
  },
  props: {
    campaignData: {
      type: Object as PropType<IJackpotCampaignDetails>,
      default: (): IJackpotCampaignDetails => ({} as IJackpotCampaignDetails)
    },
    isValid: {
      type: Boolean,
      default: false
    },
    serverErrors: {
      type: Object,
      default: (): any => {
        return {
          name: null
        };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data(): any {
    return {
      isBeforeDrawStarts: false,
      isFormsValid: {
        mainForm: false,
        streamerForm: false
      }
    };
  },
  computed: {
    isAllFormsValid(): boolean {
      return !!(this.isFormsValid.mainForm && this.isFormsValid.streamerForm);
    },
    campaignDetails: {
      get(): IJackpotCampaignDetails {
        return this.campaignData;
      },
      set(campaignDetails: IJackpotCampaignDetails): void {
        this.$emit('updateCampaign', campaignDetails);
      }
    },
    rules(): ValidationRules {
      return {
        name: [(v) => vr.required(v, 'Campaign name')],
        startAt: [
          vr.required,
          (v) => {
            const nowUtc = DateTime.utc().toFormat('yyyy-MM-dd HH:mm');

            const isValid =
              vr.isDateTimeAfterOrEqual(v, nowUtc) === true &&
              vr.isDateNotEqual(v, nowUtc) === true;

            return isValid === true
              ? true
              : 'Start date must be in the future (UTC)';
          }
        ],
        finishAt: [
          vr.required,
          (v) => vr.isDateNotEqual(v, this.campaignDetails.startAt),
          (v) => vr.isDateTimeAfterOrEqual(v, this.campaignDetails.startAt)
        ],
        jackpotExpected: [
          (v) => vr.required(v, 'Jackpot Target'),
          (v) => vr.validNumber(v),
          (v) => vr.positiveNumber(v),
          (v) => vr.integer(v),
          (v) => vr.lte(v, 1000000)
        ],
        minViewersThreshold: [
          (v) => (v ? vr.validNumber(v) : true),
          (v) => (v ? vr.positiveNumber(v) : true),
          (v) => (v ? vr.integer(v) : true),
          (v) => (v ? vr.lte(v, 1000) : true)
        ],
        jackpotBetPercentage: [
          (v) => vr.required(v, "Percentage from User's Bet Volume"),
          (v) => vr.validNumber(v),
          (v) => vr.positiveNumber(v),
          (v) => vr.lte(v, 100),
          (v) => vr.gte(v, 1),
          (v) => vr.maxPrecision(v, 4)
        ],
        startDrawThresholdMinutes: this.isBeforeDrawStarts
          ? [
              (v) => vr.required(v, 'Before Draw Starts'),
              (v) => vr.validNumber(v),
              (v) => vr.positiveNumber(v),
              (v) => vr.integer(v),
              (v) => vr.lte(v, 60),
              (v) => vr.gte(v, 1),
              (v) => {
                if (
                  !this.campaignDetails.startAt ||
                  !this.campaignDetails.finishAt
                ) {
                  return true;
                }

                const startDate = DateTime.fromFormat(
                  this.campaignDetails.startAt,
                  'yyyy-MM-dd HH:mm'
                );
                const endDate = DateTime.fromFormat(
                  this.campaignDetails.finishAt,
                  'yyyy-MM-dd HH:mm'
                );

                const diffInMinutes = endDate.diff(
                  startDate,
                  'minutes'
                ).minutes;

                return diffInMinutes > v
                  ? true
                  : `The value cannot exceed the campaign duration`;
              }
            ]
          : []
      };
    }
  },
  watch: {
    'campaignDetails.startAt'(): void {
      this.$nextTick(() => {
        if (this.campaignDetails.finishAt)
          this.$refs.finishAtCampaign.validate();

        if (this.campaignDetails.startDrawThresholdMinutes)
          this.$refs.startDrawThresholdMinutes.validate();
      });
    },
    'campaignDetails.finishAt'(): void {
      this.$nextTick(() => {
        if (this.campaignDetails.startDrawThresholdMinutes)
          this.$refs.startDrawThresholdMinutes.validate();
      });
    },
    'campaignDetails.startDrawThresholdMinutes'(): void {
      this.isBeforeDrawStarts = true;
    },
    'campaignDetails.streamer'(streamerData: IJackpotStreamer): void {
      if (streamerData) this.isFormsValid.streamerForm = true;
    },
    isAllFormsValid(value: boolean): void {
      this.$emit('update:isValid', value);
    }
  },
  methods: {
    handlerCampaignNameInput(): void {
      if (this.serverErrors.name) this.$emit('resetServerErrors', 'name');
    },
    updateStreamerHandler(streamer: IJackpotStreamer): void {
      this.campaignDetails.streamer = streamer ? { ...streamer } : null;
    }
  }
};
